import cloneDeep from 'lodash.clonedeep';

const initialState = {
  allPolicyMembers: [],
  currentComposition: null,
  currentEligibility: null,
  eligibilityDetails: null,
  membershipPolicies: null,
  membershipDetails: null,
  partner: {
    existing: {},
    newPartner: {},
  },
  children: {
    existingChildren: [],
    newChildren: [],
    terminations: [],
    payloads: [],
    addKidsQuestion: null,
  },
  referenceData: {},
  submitPolicyInProcess: false,
};

export default {
  namespaced: true,

  state: { ...initialState },

  mutations: {
    updateAllMembersDetails(state, data) {
      state.allPolicyMembers = data;
    },
    updatePartnerData(state, data) {
      state.partner = data;
    },
    updateCurrentComposition(state, data) {
      state.currentComposition = data;
    },
    updateCurrentEligibility(state, data) {
      state.currentEligibility = data;
    },
    updateChildrenData(state, data) {
      // state is updated with a spread operator so that vue reactivity kicks in
      state.children = { ...state.children, ...data };
    },
    updateMembershipPolicies(state, data) {
      state.membershipPolicies = data;
    },
    updateMembershipDetails(state, data) {
      state.membershipDetails = data;
    },
    updateEligibilityDetails(state, data) {
      state.eligibilityDetails = data;
    },
    updateReferenceData(state, data) {
      state.referenceData = data;
    },
    resetAddRemoveVuexStore(state) {
      Object.assign(state, cloneDeep(initialState));
    },
    updateSubmitPolicyInProcess(state, data) {
      state.submitPolicyInProcess = data;
    },
  },

  getters: {
    getAllMembers: (state) => {
      return state.allPolicyMembers;
    },
    getCurrentComposition: (state) => {
      return state.currentComposition;
    },
    getCurrentEligibility: (state) => {
      return state.currentEligibility;
    },
    getPartnerData: (state) => {
      return state.partner;
    },
    getChildrenData: (state) => {
      return state.children;
    },
    getMembershipPolicies: (state) => {
      return state.membershipPolicies;
    },
    getMembershipDetails: (state) => {
      return state.membershipDetails;
    },
    getEligibilityDetails: (state) => {
      return state.eligibilityDetails;
    },
    getReferenceData: (state) => {
      return state.referenceData;
    },
    getSubmitPolicyInProcess: (state) => {
      return state.submitPolicyInProcess;
    },
  },
};
